<template>
    <hr class="pwLine"/>
</template>
<script setup>
</script>
<style lang="scss" scoped>
@import './PwLineStyle.scss';
</style>
